import { settings } from '../settings/settings-util';
import { Store, Reducer } from 'redux';
import { AlmeState } from '../wireup/AlmeState';
import { InitializationPromises } from './initialization';


export default class AlmeUIModule {

    _settings: typeof settings;
    _store: Store<AlmeState> | null = null;
    _reducer: Reducer<AlmeState> | null = null;

    constructor(passedSettings: typeof settings = settings, reducer: Reducer<AlmeState> | null = null){
        this._settings = passedSettings;
        this._reducer = reducer;
    }

    initialize(store: Store<AlmeState>): void | InitializationPromises {
        this._store = store;
    }

    getReducer(): Reducer<AlmeState>{
        return this._reducer ? this._reducer : (state: AlmeState): AlmeState => state;
    }

    static getDefaultSettings(): typeof settings {
        return settings;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/types/module.ts